@if (isExpired) {
    <div class="error expired">
        <div class="icon-container">
            <mat-icon>schedule</mat-icon>
        </div>
        <span>{{ expiredMessage }}</span>
        @if (showDetails && errorDetails) {
            <span class="details">{{ errorDetails }}</span>
        }
    </div>
} @else {
    <div class="error">
        <div class="icon-container">
            <mat-icon>close</mat-icon>
        </div>
        <span>{{ genericMessage }}</span>
        @if (showDetails && errorDetails) {
            <span class="details">{{ errorDetails }}</span>
        }
    </div>
}
